import { render } from "./taskModelView.vue?vue&type=template&id=36b22e52&scoped=true"
import script from "./taskModelView.vue?vue&type=script&lang=js"
export * from "./taskModelView.vue?vue&type=script&lang=js"

import "./taskModelView.vue?vue&type=style&index=0&id=36b22e52&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b22e52"]])

export default __exports__